import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

import { IntegrationConnection } from '@shared/services/gql.service';

export interface IntegrationsState {
  items: (IntegrationConnection & { logo: string; type: string })[];
}

export function createInitialState(): IntegrationsState {
  return {
    items: [],
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'integrations' })
export class IntegrationsStore extends Store<IntegrationsState> {
  constructor() {
    super(createInitialState());
  }
}
